import type { Address } from '../types/address'

import { useFormatAddress } from './useFormatAddress'

export function useInlineFormatAddress(
  address: Address,
  {
    separator = ', ',
    includeCompany = true,
    includeCountry = true,
    includeName = false,
    withJoinedAddress = false,
  } = {},
) {
  return useFormatAddress(address, {
    includeCompany,
    includeCountry,
    includeName,
    withJoinedAddress,
  }).join(separator)
}
